import { InputHTMLAttributes, ReactNode, Ref, forwardRef } from 'react';
import { cn } from '../../../utils';
import React from 'react';

type SearchInputProps = Omit<
  InputHTMLAttributes<Omit<HTMLInputElement, 'type'>>,
  'prefix'
> & {
  prefix?: ReactNode;
  extraClassname?: string;
};

export const SearchInput = forwardRef(
  (props: SearchInputProps, ref: Ref<HTMLInputElement>) => {
    const { extraClassname, prefix, ...rest } = props;

    return (
      <div className="flex flex-row w-full !text-sm">
        {prefix && (
          <span className="font-semibold !inline-flex !border-evolve-primary !border-2 !border-r-0 items-center px-2">
            {prefix}
          </span>
        )}
        <input
          ref={ref}
          {...rest}
          type="search"
          className={cn(
            '!border-evolve-primary !border-2 !p-2 focus-visible:!border-evolve-highlight-50 focus-visible:!outline-none',
            extraClassname
          )}
        />
      </div>
    );
  }
);

SearchInput.displayName = 'SearchInput';
